import {ReduxAction} from "redux/model";
import {SeasonTypeAction} from "../model/SeasonTypeAction";

export interface SeasonAppReducer {
    selectedSeason?: string;
}

const initState: SeasonAppReducer = {
    selectedSeason: "",
};

const seasonAppReducer = (state = initState, action: ReduxAction) => {
    console.log(action)
    switch (action.type) {
        case SeasonTypeAction.SET_SELECTED_SEASON:
            return {
                ...state,
                selectedSeason: action.data.selectedSeason,
            };
        default:
            return state;
    }
};

export default seasonAppReducer;
